// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__WR+HR","searchIcon":"SearchBar_searchIcon__QhQBu"};